import AppPageDataRegion from "./AppPageDataRegion";

import "./AppPageDataRegion.scss";

export { AppPageDataRegion };
